import { get, set, forEach } from 'lodash';
import { SubmissionError, updateSyncErrors } from 'redux-form';
import { FORM_NAME } from './components/ChargerDetailsForm';

const mappingFieldWithErrors = {
  46: 'c_identity.c_name',
  105: 'c_identity.c_name',
};

export const handleChargerError = (errors) => (dispatch) => {
  const submissionErrors = {};

  forEach(get(errors, 'response.data.errors'), (error) => {
    const errorPath = get(mappingFieldWithErrors, error.code, '_error');
    let errorMessage = '';

    if (errorPath === '_error') {
      const _error = get(submissionErrors, '_error', '');

      errorMessage = `${_error}${error.message}\n`;
    } else {
      errorMessage = error.message;
    }
    set(submissionErrors, errorPath, errorMessage);
  });
  setTimeout(() => {
    dispatch(updateSyncErrors(FORM_NAME, submissionErrors));
  }, 100)
  // throw new SubmissionError(submissionErrors);
};
